module.exports = __webpack_public_path__ + "img/icon-recipients.6f6b8c23.svg";